export default __webpack_public_path__ + "static/media/GPA_Banner_Business.cd1968ac.jpg";